import { ResourceOptions } from 'react-admin';
import { MdRepeat } from 'react-icons/md';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.xbitRelayTransactionRescan;
export { XBIT_RELAY_TRANSACTION_RESCAN_PERMISSION_RESOURCE } from './constants';
export const icon = MdRepeat;
export const options: ResourceOptions = {
  label: 'module.xbitRelayTransactionRescan.title',
};
